import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import axios from 'axios'
import { formatDate } from '@/util/formatters'
import moment from 'moment'
import { ENTRADA } from '@/enums/inventory'

const state = {
  inventoryMovement: {},
  inventoryMovements: {
    data: [],
    count: 0,
    sum: [],
    amount: 0,
    limit: 25,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['description'],
    sortDesc: [false],
  },

  type: 'add',
  loading: false,
  dialog: false,
}

const mutations = make.mutations(state)

const actions = {
  add: async ({ commit, dispatch }, product) => {
    const companyId = store.get('authStore@currentCompany').id
    state.filter.startDate = moment().startOf('month').format('DD/MM/YYYY')
    state.filter.endDate = moment().endOf('month').format('DD/MM/YYYY')
    state.filter.productId = product.id
    state.filter.companyId = companyId
    state.filter.type = ''

    commit('type', 'add')
    commit('dialog', true)

    commit('inventoryMovement', {
      productId: product.id,
      productName: product.name,
      createdAt: moment().format('DD/MM/YYYY HH:mm'),
      type: ENTRADA,
      companyId: companyId,
    })
  },

  save: ({ state, dispatch }, inventoryMovement) => {
    state.loading = true
    return axios.post(`${process.env.VUE_APP_API_URL}/inventoryMovement`, inventoryMovement)
      .then((res) => {
        dispatch('get')
        showSuccess('Movimento de estoque salvo com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state, commit }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/inventoryMovement?${getQueryFromFilter(filter)}`)
      .then(res => {
        commit('inventoryMovements', res.data)
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  remove: ({ state }, { id }) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/inventoryMovement/${id}`)
      .then(_ => {
        store.dispatch('inventoryMovementStore/get')
        showSuccess('Movimento excluído com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  reloadAmount: ({ state, dispatch }, { productId, companyId }) => {
    return axios.post(`${process.env.VUE_APP_API_URL}/inventoryMovement/reload/amount`, { productId, companyId })
      .then(_ => {
        dispatch('get')
        showSuccess('Estoque atualizado com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}
const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
